export const PortalFormCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  TopRow: {
    flow: 'x',
    align: 'center space-between',
    FormTitle: { text: (el, s) => s.formTitle || 'Form', fontSize: 'A', fontWeight: '600', color: 'inkText' },
    FormStatus: {
      tag: 'span',
      text: (el, s) => s.formStatus || 'Pending',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const st = s.formStatus || 'Pending'
        if (st === 'Pending') return 'amber.15'
        if (st === 'Completed') return 'green.15'
        if (st === 'Expired') return 'red.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.formStatus || 'Pending'
        if (st === 'Pending') return 'amber'
        if (st === 'Completed') return 'green'
        if (st === 'Expired') return 'red'
        return 'inkMuted'
      }
    }
  },
  DueDate: { text: (el, s) => 'Due: ' + (s.dueDate || '--'), fontSize: 'Z', color: 'inkMuted' },
  ActionButton: {
    extends: 'Button',
    text: (el, s) => s.actionLabel || 'Complete Form',
    fontSize: 'Z',
    padding: 'Y Z',
    round: 'Z',
    background: 'teal',
    color: 'white',
    fontWeight: '600',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    marginTop: 'Y'
  }
}
